module.exports = __webpack_public_path__ + "static/media/back.3b93c8b2.svg";